import { useCallback, useContext, useRef } from 'react';
import JSZip from 'jszip';
import api from '../../../api/req';
import checkTask from '../../../api/checktask';
import { CiatAppContext } from '../../../providers';

// eslint-disable-next-line import/prefer-default-export
export const useGenerateReport = ({
  renderReportUrl, reportId,
  groups, selections, orders, filters, columns, param,
  onStart, onEnd, onDone, onError, renderer = 'json',
}) => {
  const { auth } = useContext(CiatAppContext);
  const taskId = useRef(null);
  return {
    onGenerateReport: useCallback(
      () => {
        const loader = async () => {
          const fields = selections;
          const params = {
            report: reportId,
            render: renderer,
            details: false,
            params: param,
            options: {
              group: groups,
              column: columns,
              order: orders,
              filter: filters,
              fields,
            },
          };
          const r = await api.post(renderReportUrl, auth, params, false);

          if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
          const d = await r.json();
          taskId.current = d.task_id;
          const res = await checkTask(d.task_id, auth);
          if (res.result.errors) throw new Error(res.result.errors[0]);
          if (res.result.file && renderer === 'json') {
            const reg = /data:[a-zA-Z/-]*;base64,(.*)/;
            const content = reg.exec(res.result.file)[1];
            const zip = await JSZip.loadAsync(content, { base64: true });
            const str = await zip.file('data.json').async('string');
            return JSON.parse(str);
          }
          return res.result;
        };
        onStart();
        loader()
          .then((res) => {
            onDone(res);
          })
          .catch((e) => {
            onError(e.message);
          })
          .finally(onEnd);
      },
      [onStart, selections, reportId, renderer, param, groups, columns,
        orders, filters, renderReportUrl, auth, onEnd, onError, onDone],
    ),
    onAbortReport: useCallback(
      () => {
        if (taskId.current) {
          api.delete(`${renderReportUrl}?task_id=${taskId.current}`, auth);
        }
      },
      [auth, renderReportUrl],
    ),
  };
};
